<template>
  <a-card size="small" title="筛选条件" :bordered="false">
    <a-form-model layout="inline" class="search-form">
      <a-form-model-item label="一级部门" prop="primaryDepartment">
        <a-select
          v-model="form.primaryDepartment"
          style="width: 180px;"
          mode="multiple"
          allow-clear
          placeholder="请选择一级部门"
          show-search
          :filter-option="utils.filterOption"
          @change="changePrimaryDepartment"
        >
          <a-select-option v-for="(user, index) in primaryDepartment" :key="index" :value="user.value">{{ user.label }} </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="二级部门" prop="businessDepartment">
        <a-select
          v-model="form.businessDepartment"
          style="width: 200px;"
          mode="multiple"
          allow-clear
          placeholder="请选择二级部门"
          show-search
          :filter-option="utils.filterOption"
          @change="handleChange"
        >
          <a-select-option v-for="(user, index) in businessDepartmentCompute" :key="index" :value="user.value">{{ user.label }} </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="时间" prop="time">
        <a-input-group compact>
          <a-date-picker v-model="form.startTime" :allow-clear="true" style="width: 50%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="handleChange" />
          <a-date-picker v-model="form.endTime" :allow-clear="true" style="width: 50%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="handleChange" />
        </a-input-group>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import moment from 'moment';

export default {
  name: 'DataFilter',
  data() {
    return {
      form: {
        primaryDepartment: [],
        businessDepartment: []
      }
    };
  },

  computed: {
    businessDepartment() {
      return this.$store.getters.globalConfig('business_department', []);
    },
    primaryDepartment() {
      return this.$store.getters.globalConfig('primary_department', []);
    },
    businessDepartmentCompute() {
      const pDepartment = this.form.primaryDepartment;
      if (pDepartment && pDepartment.length > 0) {
        return this.businessDepartment.filter(item => pDepartment.includes(item.parent));
      }
      return this.businessDepartment;
    }
  },

  watch: {
    filter() {
    }
  },
  created() {
  },

  methods: {
    changePrimaryDepartment() {
      this.form.businessDepartment = [];
      this.handleChange();
    },
    handleChange() {
      const __form = JSON.parse(JSON.stringify(this.form));
      if (__form.primaryDepartment && __form.primaryDepartment.length > 0) {
        if (!__form.businessDepartment || __form.businessDepartment.length === 0) {
          __form['businessDepartment'] = this.businessDepartment.filter(item => __form.primaryDepartment.includes(item.parent)).map(item => item.value);
        }
      }
      this.$emit('change', __form);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.search-form .ant-form-item {
  display: inline-block !important;
}
.ant-form-item {
  margin-bottom: 0px;
}
</style>
